<template>
  <div>
    <div class="crm-top cases-top">
      <div class="cases-top-left">
        <div class="case-tabs">
          <router-link to="/osobe">
            <div class="case-tab case-tab-osobe active">{{ $t('persons_page.persons_tab.t1') }}</div>
          </router-link>
          <router-link to="/institucije">
            <div class="case-tab case-tab-institucije">{{ $t('persons_page.persons_tab.t2') }}</div>
          </router-link>
        </div>
      </div>
      <div class="cases-top-right">
        <router-link to="/nova-osoba" class="add-case">
          {{ $t('persons_page.new_person') }}
          <div class="add-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
              <g>
                <g>
                  <path fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z" />
                </g>
              </g>
            </svg>
          </div>
        </router-link>
      </div>
      <div class="crm-line letters-filters">
        <div class="letter-search">
          <div :class="slovo_pretrazivanja == 'Sve' ? 'ls active' : 'ls'" @click="slovo_pretrazivanja = 'Sve'">
            <div class="inner-ls" @click="tableAnim">{{ $t('persons_page.all') }}</div>
          </div>
          <div :class="slovo == slovo_pretrazivanja ? 'ls active' : 'ls'" v-for="(slovo, idx) in slova" :key="idx"
            @click="slovo_pretrazivanja = slovo">
            <div class="inner-ls" @click="tableAnim">{{ slovo }}</div>
          </div>
        </div>
        <!-- <div>
          <div class="crm-dropdown">
            Vrsta osobe:
          </div>
          <select class="filters-select" v-model="leaglity_filter">
            <option :value="0">Svi</option>
            <option :value="1">Fizičke osobe</option>
            <option :value="2">Pravne osobe</option>
          </select>
        </div> -->
        <div class="open-folder-line-right">
          <div class="crm-dropdown">
            {{ $t("persons_page.filter1.title") }}
            <select class="drop-filter" id="search-group" v-model="leaglity_filter">
              <option :value="0">{{ $t("persons_page.filter1.f1") }}</option>
              <option :value="1">{{ $t("persons_page.filter1.f2") }}</option>
              <option :value="2">{{ $t("persons_page.filter1.f3") }}</option>
            </select>
            <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
          </div>
          <div class="crm-dropdown">
            {{ $t("persons_page.filter2.title") }}
            <select class="drop-filter" id="search-group" v-model="person_type">
              <option value="0">{{ $t("persons_page.filter2.f1") }}</option>
              <option value="1">{{ $t("persons_page.filter2.f2") }}</option>
              <option value="2">{{ $t("persons_page.filter2.f3") }}</option>
              <option value="3">{{ $t("persons_page.filter2.f4") }}</option>
              <option value="4">{{ $t("persons_page.filter2.f5") }}</option>
              <option value="5">{{ $t("persons_page.filter2.f6") }}</option>
              <option value="6">{{ $t("persons_page.filter2.f7") }}</option>
            </select>
            <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
          </div>
          <div class="crm-dropdown">
            Izvor
            <select class="drop-filter" id="search-group" v-model="src_id">
              <option v-for="(singl_src, key) in team" :key="key" :value="singl_src.id">{{ singl_src.name }}</option>
              
            </select>
            <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
          </div>
        </div>
      </div>
    </div>
    <div class="testtable">
      <div v-if="fetching" class="paznja-spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
      <table v-else class="responstable">
        <tr>
          <th>{{ $t('persons_page.columns.c1') }}<div class="downarrow"></div>
          </th>
          <th data-th="Detalji osobe"><span>{{ $t('persons_page.columns.c2') }}</span>
            <div class="downarrow"></div>
          </th>
          <th>{{ $t('persons_page.columns.c3') }}<div class="downarrow"></div>
          </th>
          <th>{{ $t('persons_page.columns.c4') }}<div class="downarrow"></div>
          </th>
          <th>{{ $t('persons_page.columns.c5') }}<div class="downarrow"></div>
          </th>
          <th>{{ $t('persons_page.columns.c6') }}<div class="downarrow"></div>
          </th>
          <th>{{ $t('persons_page.columns.c7') }}<div class="downarrow"></div>
          </th>
        </tr>

        <tr v-for="(pers, idx) in finalni_arr_prikaza" :key="idx">
          <td>
            <router-link :to="'/osobe/' + pers.url">{{ pers.prezime }} {{ pers.ime }}</router-link>
          </td>
          <td><span>{{ switchDate(pers.datum_upisa) }}</span></td>
          <td>
            <div v-if="pers.upisan_od != null">
              <router-link :to="'/osobe/law/' + pers.upisan_od.uid">{{ pers.upisan_od.ime }} {{ pers.upisan_od.prezime
              }}</router-link>
            </div>
          </td>
          <td>{{ pers.uloga }}</td>
          <td>
            <div v-if="pers.telefon.length > 0">
              {{ pers.telefon[0] }}
            </div>
            <v-tooltip right v-if="pers.telefon.length > 1">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
              </template>
              <p v-for="(tel, key) in pers.telefon" :key="key">{{ tel }}</p>
            </v-tooltip>
          </td>
          <td>
            <a v-if="pers.email.length > 0" :href="'mailto:' + pers.email[0]">{{ pers.email[0] }}</a>
            <v-tooltip right v-if="pers.email.length > 1">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
              </template>
              <p v-for="(mail, key) in pers.email" :key="key">
                {{ mail }}
              </p>
            </v-tooltip>
          </td>
          <td>
            <router-link v-if="pers.predmeti.length > 0"
              :to="'/case/' + pers.predmeti[pers.predmeti.length - 1].predmet.group_url + '/'">{{
                pers.predmeti[pers.predmeti.length - 1].predmet.ime_predmeta }}</router-link>
            <v-tooltip right v-if="pers.predmeti.length > 1">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
              </template>
              <p v-for="(predmet, key) in pers.predmeti" :key="key">
                {{ predmet.predmet.ime_predmeta }}
              </p>
            </v-tooltip>
          </td>
        </tr>
      </table>
    </div>

    <div class="cases-pagination">
      <Pagination ref="paginat" :finalni_arr_prikaza.sync="finalni_arr_prikaza" :br_redova="br_redova"
        :ukupna_lista="ukupna_lista" />
        <div class="cases-number">
        <span>Ukupan broj osoba: <b>{{ ukupna_lista.length }}</b></span>
        <div class="vertical-divider"></div>
        <div class="generiraj-rocisnik-button" @click="openReport()">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round"></path>
            <circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"></circle>
            <path
              d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788"
              stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span>{{ $t("page_2.report") }}</span>
        </div>
      </div>
      <div class="cases-pagination-right">
        {{ $t("page_2.row_count") }}
        <div class="broj-redova">
          <select class="drop-filter" id="search-group" v-model="br_redova">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11">
            <g>
              <g>
                <path fill="#3326ae"
                  d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z" />
              </g>
              <g>
                <path fill="#3326ae"
                  d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z" />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import moment from "moment";
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import gsap from "gsap";
import Pagination from "@/components/generalComponents/Pagination.vue";
import { handlePageLoad, storeQueryParams } from "@/router/queryHandler/index"

export default {
  components: { Pagination },
  data() {
    return {
      slovo_pretrazivanja: "",
      curr_page: 1,
      ukupna_lista: [],
      br_redova: 5,
      accessToken: "",
      all_osobe: [],
      fetching: true,
      slova: [],
      inputFizVis: false,
      finalni_arr_prikaza: [],
      person_type: 0,
      leaglity_filter: 0,
      activate_filters: false,
      queryParams: undefined,
      team : [{id : 0, name : "Svi izvori"},{id : 5, name : "Izravan upit društvu"}],
      src_id : 0
    };
  },
  async created() {
    this.queryParams = handlePageLoad("persons");

    this.accessToken = this.$store.state.aToken

    await osoba.getAllFizLeg().then((resp) => {

    this.team = this.team.concat(resp.data.all_pravnici.map((p)=>{return {id : p.link, name : p.value}}));

    console.log(this.team)});

    this.getAllPersons();

  },
  watch: {
    leaglity_filter: function () {
      if (this.activate_filters) {
        this.$refs.paginat.curr_page = 1;
        this.filterPersons();
      }

    },
    finalni_arr_prikaza: function () {
      if (this.activate_filters) {
        this.queryParams = storeQueryParams("persons", {
          curr_page: this.$refs.paginat.curr_page,
          leaglity_filter: this.leaglity_filter,
          slovo_pretrazivanja: this.slovo_pretrazivanja,
          person_type: this.person_type,
          br_redova: this.br_redova,
        });
      } else {
        this.activate_filters = true;
      }
    },
    slovo_pretrazivanja: function () {
      if (this.activate_filters) {
        this.$refs.paginat.curr_page = 1;
        this.filterPersons();
      }
    },
    person_type: function () {
      if (this.activate_filters) {
        this.getAllPersons();
        this.$refs.paginat.curr_page = 1;
      }
    },
    src_id: function () {
      if (this.activate_filters) {
        this.getAllPersons();
        this.$refs.paginat.curr_page = 1;
      }
    },
    br_redova: function () {
      if (this.activate_filters)
        this.filterPersons();
    }
  },
  methods: {
    openReport : function(){
      // this.$store.state.predmeti_report_data.all_predmeti = response.data.full_case_list;
          // this.$store.state.predmeti_report_data.is_general_view = true;
          // this.$router.push(`/predmeti-report${this.isArchived ? '?archived=true' : ''}`);
          // this.$store.state.predmeti_report_data.naslov = this.search_year.length == 4 && !this.search_year.includes('-') ? this.$t("reports.predmeti.title1",{search_year: this.search_year}) : this.$t("reports.predmeti.title2");

          this.$store.state.people_report_data.all_people = this.ukupna_lista;
          this.$store.state.people_report_data.is_general_view = true;
          this.$store.state.people_report_data.naslov = "Izvještaj o osobama u sustavu";
          this.$store.state.people_report_data.izvor = this.team.find((t)=>{return t.id == this.src_id}).name;
          this.$store.state.people_report_data.prikaz = this.$t("persons_page.filter2.f"+(parseInt(this.person_type)+1))
          this.$store.state.people_report_data.vrsta_osobe = this.$t("persons_page.filter1.f"+(parseInt(this.leaglity_filter)+1))

          this.$router.push(`/people-list-report`);
    },
    assignParamValues: function () {
      this.$refs.paginat.curr_page = this.queryParams.curr_page,
        this.leaglity_filter = this.queryParams.leaglity_filter,
        this.slovo_pretrazivanja = this.queryParams.slovo_pretrazivanja,
        this.person_type = this.queryParams.person_type,
        this.br_redova = this.queryParams.br_redova
    },
    getAllPersons() {
      this.all_osobe = [];
      this.slova = [];
      this.fetching = true
      osoba.getAllOsobe(this.person_type, this.src_id).then((resp) => {
        console.log("All data", resp.data.filter((p) => {
          return p.ime == null || p.ime == "" || p.prezime == null || p.prezime == "";
        }));
        const filteredData = resp.data.filter((p) => {
          return p.ime != null && p.ime != "" && p.prezime != null && p.prezime != "";
        });
        // this.activate_filters = true;
        filteredData.forEach((p) => {
          if (!this.slova.includes(p.prezime.substring(0, 1).toUpperCase())) {
            this.slova.push(p.prezime.substring(0, 1).toUpperCase());
          }
          this.all_osobe.push(p);
        });

        // this.all_osobe.sort((a, b) => (a.prezime > b.prezime && 1) || -1);
        this.all_osobe.sort((a, b) => (a.prezime.toUpperCase().localeCompare(b.prezime.toUpperCase(), 'hr', { sensitivity: 'base' })));
        this.slova.sort((a, b) => a.localeCompare(b, 'hr', { sensitivity: 'base' }));


        if (this.queryParams != null && this.queryParams != undefined && !this.activate_filters) {
          this.assignParamValues()
          this.filterPersons();
        } else {
          this.slovo_pretrazivanja = 'Sve';
          this.filterPersons();
        }
        this.fetching = false;

      });
    },

    getPosljednjiPredmet(popis_pred) {
      if (popis_pred == undefined) {
        return "";
      }
      // console.log(popis_pred);
      var lista_predmeta = popis_pred.split(",");
      if (lista_predmeta.length > 0) {
        return lista_predmeta[0];
      } else return popis_pred;
    },
    getPosljednjiLink(popis_link) {
      // console.log(popis_link);
      if (popis_link == undefined) {
        return "";
      }
      var url_list = popis_link.split(",");
      if (url_list.length > 0) {
        return url_list[0];
      } else return popis_link;
    },
    filterPersons() {
      console.log(this.$refs.paginat.curr_page);
      this.queryParams = storeQueryParams("persons", {
        curr_page: this.$refs.paginat.curr_page,
        leaglity_filter: this.leaglity_filter,
        slovo_pretrazivanja: this.slovo_pretrazivanja,
        person_type: this.person_type,
        br_redova: this.br_redova,
      });

      var tmp_array = this.all_osobe.slice();
      if (this.leaglity_filter > 0) {
        tmp_array = tmp_array.filter((p) => {
          return p.phys_flag == this.leaglity_filter;
        });
      }
      if (this.slovo_pretrazivanja != "Sve") {
        //filter by letter
        if (this.slovo_pretrazivanja != "") {
          tmp_array = tmp_array.filter((p) => {
            return p.prezime.substring(0, 1).toUpperCase() == this.slovo_pretrazivanja;
          });
        } else {
          if (this.slova.length > 0) {
            this.slovo_pretrazivanja = 'Sve';
            tmp_array = tmp_array.filter((p) => {
              return p.prezime.substring(0, 1) == this.slova[0];
            });
          }
        }
      }

      this.ukupna_lista = tmp_array;
      var finalni_broj = this.ukupna_lista.length / this.br_redova;
      this.$refs.paginat.all_pages = [];
      if (this.ukupna_lista.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.$refs.paginat.all_pages.push(i);
      }
      setTimeout(() => {
        this.$refs.paginat.paginirajOdabrane();
      }, 10);
    },
    switchDate(inData) {
      if (inData == "-" || inData == null) {
        return "-";
      } else {
        return moment(inData.toString()).format("l");
      }
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },
    tableAnim() {
      gsap.fromTo(
        ".responstable",
        0.4,
        { x: -10, opacity: 0 },
        { x: 0, opacity: 1 }
      );
    },
  },
  mounted() {
    // paginacija
    this.$store.state.paginacija.title = this.$t("breadcrumbs.person_mgmt");
    // body class
    document.body.classList.add("osobe-institucije");
  },
  destroyed() {
    document.body.classList.remove("osobe-institucije");
  },
};
</script>

<style></style>